import {
  Button,
  FormControl,
  InputLabel,
  makeStyles,
  Select,
  TextField,
} from '@material-ui/core';
import React, { useEffect } from 'react';
import { AiFillEdit } from 'react-icons/ai';
import { useNavigate, useParams } from 'react-router';
import { useAsignatures } from '../asginatures/Asignatures';

const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 700,
    maxWidth: '100%',
  },
  TableContainer: {
    maxWidth: '70%',
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-evenly',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    width: '22%',
  },
  input: {
    marginTop: '10px',
  },
  formSpan: {
    marginTop: '10px',
    fontFamily: 'Roboto',
    fontSize: '15px',
    color: '#888',
    textAlign: 'center',
  },
  formButtonsContainer: {
    display: 'flex',
    justifyContent: 'space-around',
    marginTop: '50px',
  },
  formControl: {
    marginTop: theme.spacing(2),
  },
  imagePicker: {
    marginTop: theme.spacing(2),
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    color: '#555',
    fontFamily: 'Roboto',
    padding: '10px',
    backgroundColor: '#f5f5f5',
    cursor: 'pointer',
    borderRadius: '5px',
  },
}));

export default function UpdateSerie() {
  const classes = useStyles();
  const [name, setName] = React.useState('');
  const [description, setDescription] = React.useState('');
  const { asignatures } = useAsignatures();
  const [image, setImage] = React.useState('');
  const [asignature, setAsignature] = React.useState('');
  const filePickerRef = React.useRef(null);
  const imagePreviewRef = React.useRef(null);
  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    fetch(`https://api.edicionesmilenio.com/api/series/${id}`)
      .then((response) => response.json())
      .then((data) => {
        if (data?.data) {
          setName(data?.data?.name);
          setDescription(data?.data?.description);
          setAsignature(data?.data?.asignature?._id);
          setImage(data?.data?.image);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, [id]);

  const handleUpdate = async () => {
    try {
      console.log(asignature);
      let formData = new FormData();
      formData.append('name', name);
      formData.append('description', description);
      formData.append('asignature', asignature);
      formData.append('image', image);

      let response = await fetch(
        `https://api.edicionesmilenio.com/api/series/${id}`,
        {
          method: 'PUT',
          body: formData,
        }
      );
      let data = await response.json();
      if (data.success === true) {
        navigate('/admin/series', { replace: true });
      } else {
        console.error(data.message);
        window.alert('Error al actualizar la serie, intente de nuevo');
      }
    } catch (err) {
      console.error(err);
      window.alert('Error al actualizar la serie, intente de nuevo');
    }
  };

  return (
    <div
      style={{
        width: '100%',
        paddingLeft: '20px',
        paddingRight: '20px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }}
    >
      <p
        style={{
          width: '100%',
          color: '#888',
          marginBottom: '50px',
          alignSelf: 'center',
          justifySelf: 'center',
          textAlign: 'center',
        }}
      >
        Estimado administrador, mediante este formulario usted podrá actualizar
        las series de la plataforma.
      </p>
      <TextField
        className={classes.input}
        id="outlined-basic"
        label="Nombre la serie"
        variant="outlined"
        value={name || ''}
        onChange={(e) => setName(e.target.value)}
      />
      <TextField
        className={classes.input}
        id="outlined-basic"
        label="Descripción"
        variant="outlined"
        value={description || ''}
        onChange={(e) => setDescription(e.target.value)}
      />
      <FormControl variant="outlined" className={classes.formControl}>
        <InputLabel id="demo-simple-select-outlined-label">
          Asignatura de la serie
        </InputLabel>

        <Select
          onChange={(e) => setAsignature(e.target.value)}
          value={asignature._id || ''}
          id="select-asignature"
          native
        >
          <option value="" disabled>
            <em>Seleccione una asignatura</em>
          </option>
          {asignatures.map((asignature) => (
            <option value={asignature?._id}>{asignature?.name}</option>
          ))}
        </Select>
      </FormControl>
      <div
        onClick={() => {
          setImage(null);
          filePickerRef.current.click();
        }}
        className={classes.imagePicker}
      >
        {image && (
          <img
            style={{ width: '50px', height: '50px', marginRight: '20px' }}
            ref={imagePreviewRef}
            src={
              typeof image === 'string'
                ? 'https://api.edicionesmilenio.com/' + image
                : URL.createObjectURL(image)
            }
            alt="preview"
          />
        )}
        <input
          ref={filePickerRef}
          style={{ display: 'none' }}
          type="file"
          name="image"
          onChange={(e) => {
            setImage(e.target.files[0]);
            const reader = new FileReader();
            reader.onload = (e) => {
              imagePreviewRef.current.src = e.target.result;
            };
            reader.readAsDataURL(e.target.files[0]);
          }}
          accept="image/*"
        />
        {image && <p>{image?.name}</p>}
        {!image && (
          <p style={{ alignSelf: 'center', justifySelf: 'center' }}>
            Seleccione una imagen para la serie
          </p>
        )}
      </div>
      <div className={classes.formButtonsContainer}>
        <Button variant="contained" onClick={handleUpdate}>
          <AiFillEdit size={15} />
          Actualizar
        </Button>
      </div>
    </div>
  );
}
